import Vue from 'vue';
import Router from 'vue-router';
import index from '@/components/index';
import demo from '@/components/demo';
import ApplyPage from '@/components/ApplyPage';
import FindDetail from '@/components/FindDetail';
import OnCheck from '@/components/OnCheck';
import SuccessCheck from '@/components/SuccessCheck';
import FailCheck from '@/components/FailCheck';
import EditPage from '@/components/EditPage';
import QRCode from '@/components/QRCode';
import ResumeDelivery from '@/components/ResumeDelivery';
Vue.use(Router);

export default new Router({
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '',
    name: 'name',
    component: index
    // meta: {
    //   title: '首页',
    //   description: '首页'
    // }
  }, {
    path: '/demo',
    name: 'demo',
    component: demo
  }, {
    path: '/ApplyPage',
    name: 'ApplyPage',
    component: ApplyPage
  }, {
    path: '/FindDetail',
    name: 'FindDetail',
    component: FindDetail
  }, {
    path: '/OnCheck',
    name: 'OnCheck',
    component: OnCheck
  }, {
    path: '/SuccessCheck',
    name: 'SuccessCheck',
    component: SuccessCheck
  }, {
    path: '/FailCheck',
    name: 'FailCheck',
    component: FailCheck
  }, {
    path: '/EditPage',
    name: 'EditPage',
    component: EditPage
  }, {
    path: '/QRCode',
    name: 'QRCode',
    component: QRCode
  }, {
    path: '/ResumeDelivery',
    name: 'ResumeDelivery',
    component: ResumeDelivery
  }]
});


// WEBPACK FOOTER //
// ./src/router/index.js